// extracted by mini-css-extract-plugin
export default {"wrapper":"JNgmzb","root":"InD22Q","rotate":"vyPKsy"};